export function objectToArray(object: string[] | undefined): string[] {
    if (object == null) return [];
    return Object.keys(object).map((key) => object[key]);
}
